// import React from 'react';

// const Dashboard = () => {
//   return (
//     <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
//       <div className="px-4 py-6 sm:px-0">
//         <div className="text-center">
//           <h2 className="text-3xl font-bold text-gray-900 mb-4">
//             Welcome to Admin Panel!
//           </h2>
//           <p className="text-gray-600 mb-8">
//             Click on the sidebar items to navigate to different sections.
//           </p>
          
//           {/* Dashboard Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <h3 className="text-lg font-semibold text-gray-900 mb-2">Users</h3>
//               <p className="text-3xl font-bold text-blue-600">1,234</p>
//             </div>
//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <h3 className="text-lg font-semibold text-gray-900 mb-2">Orders</h3>
//               <p className="text-3xl font-bold text-green-600">856</p>
//             </div>
//             <div className="bg-white p-6 rounded-lg shadow-md">
//               <h3 className="text-lg font-semibold text-gray-900 mb-2">Revenue</h3>
//               <p className="text-3xl font-bold text-purple-600">$45,230</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';

const Dashboard = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [topPages, setTopPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      await Promise.all([
        fetchAnalyticsData(),
        fetchTopPages()
      ]);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const fetchAnalyticsData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/analytics/dashboard-stats`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.details || errorData.error || 'Failed to fetch analytics data');
      }
      
      const data = await response.json();
      setAnalyticsData(data);
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      throw error;
    }
  };

  const fetchTopPages = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/analytics/top-pages`);
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.details || errorData.error || 'Failed to fetch top pages');
      }
      
      const data = await response.json();
      setTopPages(data);
    } catch (error) {
      console.error('Error fetching top pages:', error);
      throw error;
    }
  };

  const testConnection = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/analytics/test-connection`);
      const data = await response.json();
      alert(data.success ? 'Connection successful!' : `Connection failed: ${data.error}`);
    } catch (error) {
      alert(`Connection test failed: ${error.message}`);
    }
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <div>Loading analytics data...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="text-center">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              <strong className="font-bold">Error: </strong>
              <span className="block sm:inline">{error}</span>
            </div>
            <button 
              onClick={fetchData}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
            >
              Retry
            </button>
          
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Admin Dashboard
          </h2>
          <p className="text-gray-600 mb-8">
            Website analytics and performance metrics
          </p>
          
         
          
          {/* Analytics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Total Users</h3>
              <p className="text-3xl font-bold text-blue-600">
                {analyticsData?.totalUsers?.toLocaleString() || 0}
              </p>
              <p className="text-sm text-gray-500">Last 30 days</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Sessions</h3>
              <p className="text-3xl font-bold text-green-600">
                {analyticsData?.totalSessions?.toLocaleString() || 7}
              </p>
              <p className="text-sm text-gray-500">Last 30 days</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Page Views</h3>
              <p className="text-3xl font-bold text-purple-600">
                {analyticsData?.totalPageviews?.toLocaleString() || 0}
              </p>
              <p className="text-sm text-gray-500">Last 30 days</p>
            </div>
           
          </div>

          {/* Top Pages */}
          <div className="mt-8 bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Top Pages (Last 7 days)</h3>
            {topPages.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Page Path
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Views
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {topPages.map((page, index) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {page.path}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {page.views?.toLocaleString() || 0}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-gray-500 text-center py-4">No page data available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;